import   React                         ,
       { useState                      ,
	     useEffect                     }  from 'react';
import   classNames                       from 'classnames';

import   styles                           from './SalesCampaignList.module.scss';

import   AnimatedWaitingIcon2              from '../../widget/animations/animatedWaitingIcon2';
import   Trigger                          from '../../widget/actuators/Trigger';
import   ColumnTitle                      from '../../widget/dataDisplay/labels/ColumnTitle'
import   Window                           from '../../widget/windows/window';

import { Media                         ,
         MediaCategory                 }  from '../../../dataTypes/mediaManagment/types';
import { Product                       ,
         ProductCategory               }  from '../../../dataTypes/productManagment/types';
import { SalesCampaign                 }  from '../../../dataTypes/salesCampaignManagment/types';

import { getMediaList                     }  from '../../../backendServices/mediaManagment/api';
import { getMediaCategories            }  from '../../../backendServices/mediaManagment/api_category';
import { getProducts                   }  from '../../../backendServices/productManagment/api_product';
import { getProductCategories          }  from '../../../backendServices/productManagment/api_productCategory';
import { getSalesCampaigns             ,
         deleteSalesCampaign           ,
         updateSalesCampaignVisibility ,
		 transcodeSalesCampaign        ,
		 getSalesCampaignArchive       }  from '../../../backendServices/salesCampaignManagment/api_salesCampaign';


import { useTypedSelector              }  from '../../../store/useTypeSelector';
import { RootState                     }  from '../../../store/generalReducer';

import   SalesCampaignRow                 from './SalesCampaignRow';
import   SalesCampaignSheet               from './SalesCampaignSheet';

export const SalesCampaignList = () => {

  const { authentication } = useTypedSelector((state: RootState) => state.authenticationReducer);

  const [ salesCampaignSet       , setSalesCampaignSet       ] = useState<SalesCampaign[]>([]);
  const [       , setSalesCampaignSet2      ] = useState<SalesCampaign[]>([]);

  const [ mediaCategories        , setMediaCategories        ] = useState<MediaCategory[]>([]);
  const [ mediaSet               , setMediaSet               ] = useState<Media[]>([]);
  const [ productSet             , setProductSet             ] = useState<Product[]>([]);
  const [ productCategories      , setProductCategories      ] = useState<ProductCategory[]>([]);

  const [ showWaitingIcon        , setShowWaitingIcon        ] = useState(false);

  const [     , setEditSalesCampaignId    ] = useState<number | null>(null);
  const [ editSalesCampaignIndex , setEditSalesCampaignIndex ] = useState<number | null>(null);
  const [ createNewSalesCampaign , setCreateNewSalesCampaign ] = useState<boolean>(false);

  const [ showMessageWindow      , setShowMessageWindow      ] = useState ( false );
  const [ message                , setMessage                ] = useState ( <></> );

  const [ showConfirmation       , setShowConfirmation       ] = useState (false);
  const [ salesCampaignToDelete  , setSalesCampaignToDelete  ] = useState<SalesCampaign | null>(null);

  useEffect(() => {

    const fetchData = async () => {

      try
       {
        setShowWaitingIcon(true);

        const [mediasResult, mediaCategoriesResult, productsResult, productCategoriesResult, salesCampaignResult] = await Promise.all([
          getMediaList([], authentication.admin?.id)          ,
          getMediaCategories() ,
          getProducts(undefined, authentication.admin?.id)        ,
          getProductCategories()        ,
          getSalesCampaigns(authentication.admin?.id)        ,
        ]);

        console.log (salesCampaignResult)

        if (mediasResult.payload)
         {
          setMediaSet (mediasResult.payload);
         }

        if (mediaCategoriesResult.payload)
         {
          setMediaCategories (mediaCategoriesResult.payload.sort((a, b) => a.rank - b.rank));
         }

        if (productsResult.payload)
         {
          setProductSet (productsResult.payload);
         }

        if (productCategoriesResult.payload)
         {
          setProductCategories (productCategoriesResult.payload.sort((a, b) => a.rank - b.rank));
         }

        if (salesCampaignResult.payload)
         {
          setSalesCampaignSet (salesCampaignResult.payload);
         }
       }
      catch (error)
       {
        console.error('Error fetching data:', error);
       }
      finally
       {
        setShowWaitingIcon(false);
       }
    };

    fetchData();
  }, []);

  useEffect(() => {

    console.log (salesCampaignSet)
  }, [salesCampaignSet]);
  
 const reinit = async () => {
  console.log("🔄 REINIT LANCÉ");

  setShowWaitingIcon(true);

  const salesCampaignResult = await getSalesCampaigns(authentication.admin?.id);
  console.log("📦 Nouvelle donnée reçue :", salesCampaignResult.payload);

  if (salesCampaignResult.payload) {
    setSalesCampaignSet([...salesCampaignResult.payload]); // 🔁 Nouvelle référence
    console.log("✅ Donnée mise à jour");
  }

  setShowWaitingIcon(false);
};

  const handleEditionClick = (index: number) => {
    setEditSalesCampaignId(salesCampaignSet[index].id); // Passer en mode carousel avec l'ID de la vidéo
    setEditSalesCampaignIndex(index); // Passer en mode carousel avec l'ID de la vidéo
  };

  const handleDeleteClick = (salesCampaign: SalesCampaign) => {

    setSalesCampaignToDelete (salesCampaign);
    setShowConfirmation(true);
  };

  const handleTranscodeClick = ( salesCampaign: SalesCampaign ) => {

    const fct = async ( id: number) => {
		const result = await transcodeSalesCampaign(id);
        
		if ( result.code === 1)
		 {
          reinit ()
		 }
		 else {
			 console.log ("Une erreur s'est produite")
		 }
	}
	
	fct (salesCampaign.id)
/*
    setSalesCampaignSet((prev) =>
      prev.map((sc) =>
        sc.id === salesCampaign.id
          ? { ...sc, status: 0 } 
          : sc
      )
    );

    setSalesCampaignSet2((prev) =>
      prev.map((sc) =>
        sc.id === salesCampaign.id
          ? { ...sc, status: 0 }
          : sc
      )
    );
	
*/	
  }

  const handleTranscoded = ( salesCampaign: SalesCampaign ) => {

    reinit ()
  }

  const handleDownloadClick = ( salesCampaign: SalesCampaign ) => {

    getSalesCampaignArchive ( salesCampaign.id )
  }

  const handleDeleteConfirmation = async (confirmed: boolean)=> {

    if ( confirmed && salesCampaignToDelete )
     {
      try
       {
        const response = await deleteSalesCampaign (salesCampaignToDelete.id);

        if (response.code === 1)
              {
               setSalesCampaignSet((prev) => prev.filter((salesCampaign) => salesCampaign.id !== salesCampaignToDelete.id));
               setSalesCampaignSet2((prev) => prev.filter((salesCampaign) => salesCampaign.id !== salesCampaignToDelete.id));
              // setMessage(<>La campagne de vente a été supprimée</>);
              }
         else {
               console.warn(`Impossible de supprimer la campagne de vente ID ${salesCampaignToDelete.id} : ${response.comment}`);
               setMessage (
                           response.code === -103
                           ? <>Impossible de supprimer la campagne de vente car elle est déjà liée à d'autres ressources</>
                           : <>Impossible de supprimer le campagne de vente </>
                          );
               setShowMessageWindow(true);		  
              }
       }
      catch (error)
       {
        console.error(`Erreur lors de la suppression de la campagne ID ${salesCampaignToDelete.id}:`, error);
        setMessage(<>Impossible de supprimer la campagne de vente</>);
        setShowMessageWindow(true);
       }
     }

    setShowConfirmation(false);
    setSalesCampaignToDelete(null);
  };

  const handleVisibilityChange = (salesCampaignId: number) => {

    setSalesCampaignSet ((prevSalesCampaignSet) => {

      const updatedSalesCampaignSet = prevSalesCampaignSet.map((salesCampaign) => {

        if (salesCampaign.id === salesCampaignId )
         {
          const newState = !(salesCampaign.active); // Inverser l'état
          updateSalesCampaignVisibility(salesCampaign.id, newState); // Appeler l'API
          return { ...salesCampaign, active: newState }; // Retourner le média mis à jour
         }

        return salesCampaign;
       });

    // Mettre à jour `setMediaSet2` aussi
    setSalesCampaignSet2 (updatedSalesCampaignSet);

    return updatedSalesCampaignSet;
   });
  };


  const handleNewSalesCampaignCreationClick = () => {
    setCreateNewSalesCampaign (true)
  };

  const handleCreate = ( id: number ) => {

    setCreateNewSalesCampaign (false)
	setEditSalesCampaignIndex (null)
    reinit ()
  }

  const handleEdit = ( id: number ) => {

    setCreateNewSalesCampaign (false)
	setEditSalesCampaignIndex (null)
    reinit ()
  }


  const renderComponent = () : JSX.Element => {

    if ( createNewSalesCampaign )
          {
           // Est-ce qu'on affiche une fiche vierge pour créer une nouvelle campagne de ventes

           return <SalesCampaignSheet medias                 = {mediaSet}
                                      mediaCategories        = {mediaCategories}
                                      products               = {productSet}
									  productCategories      = {productCategories}
									  existingSalesCampaigns = {salesCampaignSet}
									  onCreate               = {handleCreate}/>
          }
     else {
           if ( editSalesCampaignIndex !== null )
                 {
                  // Est-ce qu'on affiche la fiche d'une campagne existante pour édition

                  return <SalesCampaignSheet medias                 = {mediaSet}
                                             mediaCategories        = {mediaCategories}
                                             products               = {productSet}
                                             productCategories      = {productCategories}
									         existingSalesCampaigns = {salesCampaignSet}
                                             salesCampaign          = {salesCampaignSet[editSalesCampaignIndex]}
                                             onEdit                 = {handleEdit} />
                 }
            else {
                  return (

                          <>

                            <div className={classNames(styles.upper_bar)}>

                               <div className={classNames(styles.upper_bar_right)}>
                                  <Trigger name    = "Créer une campagne"
                                           onClick = {handleNewSalesCampaignCreationClick}
                                           variant = "tailwind2"  />
                               </div>
                            </div>

                            <div className={classNames(styles.list_container)}>
                              <div className={classNames(styles.list)}>
                                 <ColumnTitle titles = {[ 'Index ' , 'Titre' , 'Date de début' , 'Date de fin'  , ''    , 'Actions' , 'Visibilité']}
                                              widths = {[ '50px  ' , 'auto'  , '150PX'         , '150px'        , '1px' , '159px'   , '80px'      ]} />
                                 {
                                  salesCampaignSet.map((salesCampaign, index) => (

                                    <SalesCampaignRow key                = {salesCampaign.id}
                                                      salesCampaign      = {salesCampaign}
                                                      index              = {index}
                                                      onEdit             = {handleEditionClick}
                                                      onDelete           = {handleDeleteClick}
                                                      onVisibilityToggle = {handleVisibilityChange} 
													  onTranscodeClick   = {handleTranscodeClick}
                                                      onTranscoded       = {handleTranscoded}
                                                      onDownloadClick    = {handleDownloadClick} />
                                   ))
                                 }
                              </div>
                            </div>

                          </>
                         )
                        }
                 }

  }

  const handleMessageWindowClose = () => {

    setShowMessageWindow (false)
  }

  return (
    <div className={classNames(styles.root)}>

      { showWaitingIcon && <AnimatedWaitingIcon2 /> }

      {
        showMessageWindow &&
        <Window message                 = {message}
                messageType             = "information"
                onClickOnValidateButton = {handleMessageWindowClose} 
				validButtonText         = "Ok"/>
      }

      {
        showConfirmation &&
        <Window message                 = {<>{`Êtes-vous sûr de vouloir supprimer la campagne de vente ${salesCampaignToDelete?.name} ?`}</>}
                messageType             = "question"
                onClickOnValidateButton = {() => handleDeleteConfirmation(true)}
                onClickOnCancelButton   = {() => handleDeleteConfirmation(false)} 
				validButtonText         = "Oui"
                cancelButtonText        = "Non"  />
      }

      { renderComponent () }

    </div>
  );
};

export default SalesCampaignList;
